<template>
	<div class="detail-info">
		<div v-if="titleBlock" class="page-subtitle">{{ titleBlock }}</div>
		<div v-if="!canEdit" class="detail-info__card">
			{{ text }}
		</div>
		<InputTextarea v-if="canEdit" v-model="value" :value="text"/>
	</div>
</template>

<script>
import InputTextarea from "@/components/base/utils/formElements/InputTextarea.vue";

export default {
	name: "DetailInfo",
	components: {InputTextarea},
	emits:['update:modelValue'],
	props: {
		titleBlock: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		canEdit: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	}
}
</script>
